@if (!item.external && !item.twoLines) {
  <a
    mat-list-item
    (click)="onItemSelected(item, $event)"
    [ngClass]="{
      'mat-toolbar mat-primary activeMenu': item.route ? isActive(item) : false,
      expanded: expanded,
      disabled: item.disabled,
    }"
    class="menu-list-item"
  >
    @if (item.subItemIcon) {
      <span
        class="iconify routeIcon sub-item-icon"
        matListItemIcon
        [attr.data-icon]="item.icon"
      ></span>
    } @else {
      <i-tabler [name]="item.icon" class="iconify routeIcon"></i-tabler>
    }
    <span class="hide-menu">{{ item.name | translate }}</span>

    @if (item.children && item.children.length) {
      <span class="arrow-icon" fxFlex>
        <span fxFlex></span>
        <mat-icon [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'">
          expand_more
        </mat-icon>
      </span>
    }
    @if (item.chip) {
      <span>
        <span
          class="{{
            item.chipClass
          }} p-x-8 p-y-4 item-chip f-w-500 rounded-pill "
          >{{ item.chipContent }}</span
        >
      </span>
    }
  </a>
}

<!-- external Link -->

@if (item.external) {
  <mat-list-item
    onClick="window.open('//google.com')"
    class="menu-list-item"
    target="_blank"
  >
    <span
      class="iconify routeIcon"
      matListItemIcon
      [attr.data-icon]="item.icon"
    ></span>
    <span class="hide-menu">{{ item.name | translate }}</span>
  </mat-list-item>
}

<!-- children -->
@if (expanded) {
  @for (child of item.children; track child) {
    <app-nav-item
      [item]="child"
      (click)="onSubItemSelected(child)"
      [depth]="depth + 1"
    >
    </app-nav-item>
  }
}
